import { Injectable } from "@angular/core";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { defer, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";

/**
 * @deprecated - [fabric-deprecated] - Use UserDeviceService from svc-platform instead.
 * */
@Injectable({ providedIn: "root" })
export class UserDeviceService {
	/**
	 * @deprecated - [fabric-deprecated] - Use `PlatformServiceValue.GetDevice` instead
	 * */
	getUserDevice$(): Observable<{ visitorId: string; components: any }> {
		return defer(() => FingerprintJS.load()).pipe(
			switchMap((deviceAgent) => defer(() => deviceAgent.get())),
			map((result) => ({ visitorId: result.visitorId, components: result.components }))
		);
	}
}
